var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-6"},[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_vm._e(),(!_vm.loading && !_vm.isBlocked)?_c('s-new-service',{attrs:{"service":_vm.additionalService}}):_vm._e(),(_vm.isBlocked)?_c('s-new-service-blocked',{attrs:{"service":_vm.additionalService}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }